<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <dropdown :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" v-model="repeats" :items="paragraphs" width="150px" :class="['mr-1']" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <lorem-ipsum :repeats="repeats[0]" :class="['text-sm']" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageLoremIpsum',
  data () {
    return {
      repeats: [3],
      paragraphs: Array.from(Array(10).keys()).map(value => {
        value = value + 1
        return {value, text: `${value} paragraph${value > 1 ? 's' : ''}`}
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/lorem-ipsum.vue